import penetrometro1 from '../penetrometro/penetrometro1.png'


const imagepenetrometro = [
    penetrometro1,
]

export default imagepenetrometro